enum Acquirer {
  STRIPE = "STRIPE",
  HIGHNOTE = "HIGHNOTE",
}

export default Acquirer;
